export const chunks = (list, chunkCount) => {
  const chunkSize = Math.ceil(list.length / chunkCount);
  var R = [];
  for (var i = 0; i < list.length; i += chunkSize)
    R.push(list.slice(i, i + chunkSize));
  return R;
};

export const chunkColumns = (list, chunkColumnsCount) => {
  var R = [];
  for (let i = 0; i < chunkColumnsCount; i += 1) {
    R.push([]);
  }
  for (let i = 0; i < list.length; i += 1) {
    R[i % chunkColumnsCount].push(list[i]);
  }
  return R;
};

export const randomId = (length = 10) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const lightenDarkenColor = (color, amount) => {
  let usePound = false;
  if (color[0] == "#") {
    color = color.slice(1);
    usePound = true;
  }

  const num = parseInt(color, 16);

  let r = (num >> 16) + amount;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amount;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amount;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
};

export const tryParseInt = (str, defaultValue) => {
  if (typeof str === "number") {
    return parseInt(str);
  }

  var retValue = defaultValue;

  if (str !== null && str !== undefined) {
    if (str.length > 0) {
      if (!isNaN(str)) {
        retValue = parseInt(str);
      }
    }
  }
  return retValue;
};

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const toCurrencyValue = value => {
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });
};
